// debounced-resize.js
jQuery(function ($) {

    var resizeTimeout = null;

    $(window).on('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function(){
            $(window).trigger('debounced-resize');
        }, 300);
    });

});